import * as signalR from "@microsoft/signalr";
import { tlTL } from "@mui/material/locale";
import React, { useEffect, useReducer, useRef } from "react";
import { useSelector } from "react-redux";
import { selectAccessToken } from "../../features/auth/authSlice";
import AlertContext from "./PopUpAlertContext";
import { AlertState, AddAlertParam } from "./type";

type DispatchType = {
    type: string;
    dispatch: React.Dispatch<DispatchType>
    content: AlertAction | string
}

type AlertAction = { alert: AlertState, time: number, isSystemNotification?: boolean }

function iOS() {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

const reducer = (state: Map<string, AlertState>, action: {
    type: string, dispatch: React.Dispatch<DispatchType>, content: AlertAction | string
}) => {
    state = new Map(state)
    var uuid = crypto.randomUUID()
    if (action.type == "push") {
        var alertAction = action.content as AlertAction
        state.set(uuid, alertAction.alert)
        if (alertAction.time > 0)
            setTimeout(() => {
                action.dispatch({ type: "pop", dispatch: action.dispatch, content: uuid })
            }, alertAction.time)
        else
            alertAction.alert.onClose = () => action.dispatch({ type: "pop", dispatch: action.dispatch, content: uuid })


        if (!iOS() && alertAction.isSystemNotification === true)
            new Notification(alertAction.alert.title, { body: alertAction.alert.body })
    }
    else if (action.type == "pop")
        state.delete(action.content as string)
    return state
}

const AlertProvider = ({ children }: { children: React.ReactNode }) => {
    const [alerts, dispatch] =
        useReducer
            (
                reducer,
                new Map<string, AlertState>()
            )

    const addAlert = ({ title, body, type, onClick, time, isSystemNotification }: AddAlertParam) => {
        dispatch({ type: "push", dispatch: dispatch, content: { alert: { title: title, body: body, type: type, onClick: onClick }, time: time, isSystemNotification: isSystemNotification } })
    }

    const locateStorageToken = localStorage.getItem('accessToken')
    const reduxStoreToken = useSelector(selectAccessToken)
    const accessToken = reduxStoreToken || locateStorageToken

    const connectionRef = useRef<signalR.HubConnection | null>()

    const initConnection = () => {
        if (connectionRef.current != null) {
            connectionRef.current.stop()
        }

        connectionRef.current =
            new signalR.HubConnectionBuilder()
                .withUrl(process.env.REACT_APP_BASE_URL + "globalAlertHub", { accessTokenFactory: () => accessToken })
                // .withUrl(process.env.REACT_APP_BASE_URL + "globalAlertHub")
                .build()
        connectionRef.current.start().then(() => {
            connectionRef.current!.invoke("SubscribeToCompanyAlert");
        }).catch((err: any) => {
            return console.error(err.toString());
        })

        connectionRef.current.on("ReceiveGlobalAlert", (title: string, body: string) => {
            // console.log("data", data);
            addAlert({ title: title, body: body, type: "error", time: 5000 })
        })
    }

    useEffect(() => {
        initConnection()

        setInterval(() => {
            if (connectionRef.current == null || connectionRef.current.state == signalR.HubConnectionState.Disconnected)
                initConnection()
        }, 5000)

        // if (Notification.permission !== "granted") {
        //     addAlert("The browser currently forbiddens the site to send notification. Please enable the function to receive notification.", "warning", 5000, false,
        //         () => {
        //             console.log("request!")
        //             Notification.requestPermission()
        //         })
        //     // …
        // }
        if (!iOS())
            Notification.requestPermission().then((permission) => {
                // If the user accepts, let's create a notification
                if (permission !== "granted") {
                    addAlert(
                        {
                            title: "The browser currently forbiddens the site to send notification. Please enable the function to receive notification.",
                            type: "warning",
                            time: 5000,
                            onClick: () => Notification.requestPermission()
                        }
                    )
                    // …
                }
            });
    }, [accessToken])

    return (
        <AlertContext.Provider
            value={{
                alerts,
                addAlert,
            }}
        >
            {children}
        </AlertContext.Provider>
    );
};

export default AlertProvider